import { render, staticRenderFns } from "./UploadSusaView.vue?vue&type=template&id=73799a99"
import script from "./UploadSusaView.vue?vue&type=script&lang=js"
export * from "./UploadSusaView.vue?vue&type=script&lang=js"
import style0 from "./UploadSusaView.vue?vue&type=style&index=0&id=73799a99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports